import apple from "../../../assets/png/apple.png";
import google from "../../../assets/png/google.png";
import facebook from "../../../assets/png/facebook.png";
import search from "../../../assets/png/search.png";
import { useState } from "react";
import { Tooltip, Spin, Popover, message as AndMessage, Checkbox } from "antd";
import nation from "../../../data/LoginModal/nation.json";
import {
  applelogin,
  googlelogin,
  oauthlogin,
  peek,
} from "../../../fetch/api/login";

const AccountNumber = ({ setAvatar, toVerificationCode, toInformation }) => {
  const [phoneValue, setPhoneValue] = useState("");
  const [clauseValue, setClauseValue] = useState(false);
  const [tipsValue, setTipsValue] = useState(false);
  window.AppleID.auth.init({
    clientId:
      process.env.NODE_ENV == "development"
        ? "live.stadeo.dev-widget"
        : "live.stadeo-widget",
    redirectURI: "https://" + window.location.host,
    scope: "name email",
    response_type: "code id_token",
    state: "apple_login",
    usePopup: true,
  });
  // apple
  async function openAppleLogin() {
    try {
      const response = await window.AppleID.auth.signIn();
      if (response.authorization.id_token) {
        toggle(true);
        applelogin({
          token: response.authorization.id_token,
          user_id: "",
          first_name: response.name ? response.name.firstName : "",
          last_name: response.name ? response.name.lastName : "",
        }).then(async (res) => {
          if (res) {
            const { code, data, message } = res;
            if (code == 200) {
              if (data.login_count === 1) {
                localStorage.setItem("login", JSON.stringify(data));
                toInformation();
                return;
              }
              loginSuccess(data);
            } else {
              AndMessage.error({
                content: message,
                maxCount: 1,
              });
            }
          }
        });
      }
    } catch (error) {
      console.log(error);
    }
  }
  // google
  function gload(fn) {
    window.google.accounts.id.initialize({
      client_id:
        process.env.NODE_ENV == "development"
          ? "454991601021-m7bja0o87tg6a9pphrki2h3rl77gufh9.apps.googleusercontent.com"
          : "832539880391-21vigr1opggfpohrm85k98cckm0n2m57.apps.googleusercontent.com",
      callback: fn,
    });
    window.google.accounts.id.renderButton(
      document.getElementById("g_id_signin2"),
      {
        theme: "outline",
        size: "medium",
        type: "icon",
        text: "signin_with",
        shape: "circle",
      }
    );
  }
  async function handleGoogleCredentialResponse(response) {
    if (response.credential) {
      toggle(true);
      googlelogin({
        token: response.credential,
      }).then(async (res) => {
        if (res) {
          const { code, data, message } = res;
          if (code == 200) {
            if (data.login_count === 1) {
              localStorage.setItem("login", JSON.stringify(data));
              toInformation();
              return;
            }
            loginSuccess(data);
          } else {
            AndMessage.error({
              content: message,
              maxCount: 1,
            });
          }
        }
      });
    }
  }
  gload(handleGoogleCredentialResponse);
  // facebook

  function openFacebookLogin() {
    // window.fbAsyncInit = function () {
    // @ts-ignore：
    // eslint-disable-next-line no-undef
    FB.init({
      appId: "464557828418753",
      autoLogAppEvents: true,
      xfbml: true,
      version: "v12.0",
    });
    // };
    // @ts-ignore：
    // eslint-disable-next-line no-undef
    FB.getLoginStatus((response) => {
      if (response.status === "connected") {
        loginWithFbAuth(
          response.authResponse.accessToken,
          response.authResponse.userID
        );
      } else {
        // @ts-ignore：
        // eslint-disable-next-line no-undef
        FB.login(
          (res) => {
            if (res.status === "connected") {
              loginWithFbAuth(
                res.authResponse.accessToken,
                res.authResponse.userID
              );
            }
          },
          { scope: "public_profile,email" }
        );
      }
    });
  }
  function loginWithFbAuth(accessToken, userID) {
    // @ts-ignore：
    // eslint-disable-next-line no-undef
    FB.api("/me?fields=name,id,email", function (res) {
      toggle(true);
      oauthlogin({
        oauth_id: userID,
        oauth_account: res.name,
        oauth_email: res.email,
        access_token: accessToken,
      }).then(async (res) => {
        const { code, data, message } = res;
        if (code == 200) {
          if (data.login_count === 1) {
            localStorage.setItem("login", JSON.stringify(data));
            toInformation();
            return;
          }
          loginSuccess(data);
        } else {
          AndMessage.error({
            content: message,
            maxCount: 1,
          });
        }
      });
    });
  }

  // get login info
  function loginSuccess(data) {
    peek(
      {
        query_id: data.guid,
      },
      {
        headers: {
          UserId: data.guid,
          Token: data.token,
        },
      }
    ).then((res) => {
      const { code, data, message } = res;
      if (code == 200) {
        localStorage.setItem("login", JSON.stringify(data));
        setAvatar();
      } else {
        AndMessage.error({
          content: message,
          maxCount: 1,
        });
      }
      toggle(false);
    });
  }
  const [loading, setLoading] = useState(false);

  const toggle = (checked) => {
    setLoading(checked);
  };
  const [open, setOpen] = useState(false);
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const [nationText, setnationText] = useState(nation[0].dial_code);
  const [nationUrl, setnationUrl] = useState(nation[0].code);
  const [nationCopy, setNationCopy] = useState(nation);

  return (
    <Spin spinning={loading}>
      <div className="text-center pt-[48px]">
        <p className="text-[9px] text-stadeo-grayed-2 font-worksans">
          Login via social
        </p>
      </div>
      <div className="w-full flex justify-center mt-[10px]">
        <div id="abc" className="flex space-x-[10px]">
          <div
            className="w-[46px] h-[46px] rounded-full bg-stadeo-grayed-3"
            onClick={() => {
              if (!clauseValue) {
                setTipsValue(true);
                return;
              }
              openAppleLogin();
            }}
          >
            <div className="pt-[11px]">
              <img
                alt="apple"
                src={apple}
                className="w-[18px] m-auto cursor-pointer"
              />
            </div>
          </div>

          <div
            className="w-[46px] h-[46px] rounded-full bg-stadeo-grayed-3 relative overflow-hidden"
            onClick={() => {
              if (!clauseValue) {
                setTipsValue(true);
                return;
              }
            }}
          >
            <div
              id="g_id_signin2"
              className="cursor-pointer absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] overflow-hidden"
            ></div>
            <div
              className={`w-[100%]  h-[100%] z-1 flex items-center justify-center rounded-full absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] bg-stadeo-grayed-3 ${
                clauseValue ? "pointer-events-none" : "pointer-events-auto"
              }`}
            >
              <img
                alt="apple"
                src={google}
                className="w-[21px] m-auto cursor-pointer"
              />
            </div>
          </div>

          <div
            className="w-[46px] h-[46px] rounded-full bg-stadeo-grayed-3"
            onClick={() => {
              if (!clauseValue) {
                setTipsValue(true);
                return;
              }
              openFacebookLogin();
            }}
          >
            <div className="pt-[10px]">
              <img
                alt="apple"
                src={facebook}
                className="w-[25px] m-auto cursor-pointer"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="w-full mt-[17px] flex justify-center space-x-[3px]">
        <div className="bg-stadeo-grayed-2 w-[66px] h-[1px] mt-[10px]"></div>
        <div className="text-center">
          <p className="text-[9px] text-stadeo-grayed-2 font-worksans">
            or use your phone
          </p>
        </div>
        <div className="bg-stadeo-grayed-2 w-[66px] h-[1px] mt-[10px]"></div>
      </div>
      <div className="w-[221.41px] h-[38.84px] flex m-auto mt-[17px] mb-[11px] border border-[#BDBDBD] rounded-[5.2px] overflow-hidden">
        <Popover
          content={
            <div className="w-[185px] h-[133px] overflow-y-auto flex flex-col items-center">
              <div className="border border-[#BDBDBD] rounded-[5.2px]  overflow-hidden pl-[5px] pr-[5px] flex items-center mb-[6px]">
                <img className="w-[10px] h-[10px]" src={search} alt="" />
                <div className="flex-1 flex justify-center items-center font-semibold p-[5px]">
                  <input
                    className="outline-0 w-[100%] text-[12px]"
                    type="text"
                    placeholder="Search country..."
                    onChange={(e) => {
                      if (e.target.value === "") {
                        setNationCopy(JSON.parse(JSON.stringify(nation)));
                      } else {
                        setNationCopy([]);
                        let nationMap = [];
                        let neg = /^[A-Za-z]$/;
                        let country = e.target.value.charAt(0);
                        if (neg.test(country)) {
                          for (let item of JSON.parse(JSON.stringify(nation))) {
                            if (
                              item.name
                                .toUpperCase()
                                .indexOf(e.target.value.toUpperCase()) !== -1
                            ) {
                              nationMap.push(item);
                            }
                          }
                        } else {
                          for (let item of JSON.parse(JSON.stringify(nation))) {
                            if (item.dial_code.indexOf(e.target.value) !== -1) {
                              nationMap.push(item);
                            }
                          }
                        }
                        setNationCopy(nationMap);
                      }
                    }}
                  />
                </div>
              </div>
              <div className=" overflow-y-auto flex-1 w-[100%] no-scrollbar">
                {nationCopy.map((item) => {
                  return (
                    <div
                      key={item.code}
                      className={`flex items-center   rounded-[6px] mb-[5px] mt-[5px]  text-[12px] cursor-pointer pt-[5px] pb-[5px] ${
                        item.dial_code === nationText
                          ? "text-[#283AC6] bg-[#283AC6]/[.1] border"
                          : ""
                      }`}
                      onClick={() => {
                        setnationText(item.dial_code);
                        setOpen(false);
                        setnationUrl(item.code);
                      }}
                    >
                      <span className="ml-[10px]  w-[35px] text-ellipsis overflow-hidden">
                        {item.dial_code}
                      </span>
                      <span>{item.name}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          }
          placement="bottomLeft"
          open={open}
          onOpenChange={handleOpenChange}
          trigger="click"
        >
          <div className="w-[60px] h-[100%] flex justify-center items-center text-[12px] cursor-pointer p-[5px]">
            <img
              className=" w-[21px] h-[14px]"
              src={require("../../../assets/nationPng/" +
                nationUrl.toLowerCase() +
                ".png")}
              alt=""
            />
            <span className="flex-1 pl-[3px]  text-ellipsis overflow-hidden whitespace-nowrap text-center">
              {nationText}
            </span>
          </div>
        </Popover>
        <div className="h-[16.83px] w-[1px] bg-[#E0E0E0] m-auto "></div>
        <div className="flex-1 flex justify-center items-center font-semibold p-[5px]">
          <input
            className="outline-0 w-[100%] text-[12px] font-medium"
            placeholder="348 000 00 00"
            value={phoneValue}
            onChange={(e) => {
              setPhoneValue(e.target.value);
            }}
          />
        </div>
      </div>
      <div className="flex m-auto scale-[calc(7.75_/_12)] relative">
        <div className="w-[30px] flex items-center origin-[10px] scale-[2]">
          <Tooltip
            open={tipsValue}
            placement="top"
            title={"required"}
            arrow={true}
          >
            <Checkbox
              onChange={(e) => {
                setClauseValue(e.target.checked);
                if (e.target.checked) {
                  setTipsValue(false);
                }
              }}
            ></Checkbox>
          </Tooltip>
        </div>

        <div
          className={`w-[263px] text-[12px] ${tipsValue ? "text-[red]" : ""}`}
        >
          <span>
            I agree the Terms and Conditions and the Privacy Policy.{" "}
            <span
              className={`cursor-pointer text-[Blue] underline ${
                tipsValue ? "text-[red]" : ""
              }`}
              onClick={() => {
                window.open("https://www.stadeo.com/terms-and-condition");
              }}
            >
              Read more...
            </span>
          </span>
        </div>
      </div>
      <div
        className={`w-[219px] h-[30px] text-white  flex items-center justify-center rounded-[57px] m-auto mt-[15px]  cursor-pointer ${
          phoneValue && clauseValue ? "bg-[#09B251]" : "bg-[#BDBDBD]"
        }`}
        onClick={() => {
          if (phoneValue && clauseValue) {
            toVerificationCode(phoneValue, nationText);
          }
        }}
      >
        <span className="scale-[calc(9.16_/_12)] text-[12px] font-semibold">
          SIGN UP
        </span>
      </div>
    </Spin>
  );
};

export default AccountNumber;
